import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { BackgroundDefaultLayoutComponent } from './containers/background-default-layout/background-default-layout.component';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { RegisterComponent } from './views/register/register.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { AuthGuard } from './auth.guard';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ELedgerLoginComponent } from './e-ledger-login/e-ledger-login.component';
import { AChallanPaymentCheckComponent } from './a-challan-payment-check/a-challan-payment-check.component';
import { ETaxServiceContentComponent } from './e-tax-service-content/e-tax-service-content.component';
import { ETdsComponent } from './e-tds/e-tds.component';
import { ETaxPaymentComponent } from './e-tax-payment/e-tax-payment.component';
import { FAQComponent } from './faq/faq.component';
import { ELedgerComponent } from './e-ledger/e-ledger.component';
import { UserManualComponent } from './user-manual/user-manual.component';
import { TrpRedirectComponent } from './trp/trp-redirect/trp-redirect.component';
import { TrpLandingComponent } from './trp-landing/trp-landing.component';
import { TaxCertificateManualComponent } from './tax-certificate-manual/tax-certificate-manual.component';
import { FaqNewComponent } from './faq-new/faq-new.component';
import{ SpecialRegistrationManualComponent } from './special-registration-manual/special-registration-manual.component';
import {
  SpecialRegistrationEmailVerificationManualComponent
} from "./special-registration-email-verification-manual/special-registration-manual.component";
import { IncomeTaxCertificateComponent } from './tax-certificates/income-tax-certificate/income-tax-certificate.component';
import { AacknowledgementSlipComponent } from './tax-certificates/acknowledgement-slip/aacknowledgement-slip.component';
import { TaxCertificatesModule } from './tax-certificates/tax-certificates.module';

export const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'auth',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    redirectTo: 'landing-page',
    pathMatch: 'full',
  },
  {
    path: "landing-page",
    component: LandingPageComponent,
    data: {
      title: "Landing Page",
    },
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: "eLedger-login",
    component: ELedgerLoginComponent,
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: "Register Page",
    },
  },
  {
    path: "payment-success/:tin",
    component: PaymentSuccessComponent,
    data: {
      title: "Payment Status",
    },
  },
  {
    path: "achallan-payment-check",
    component: AChallanPaymentCheckComponent,
    data: {
      title: "aChallan Payment check",
    },
  },
  {
    path: "payment-redirect",
    component: AChallanPaymentCheckComponent,
    data: {
      title: "Payment redirect",
    },
  },
  {
    path: "e-tax-service-content",
    component: ETaxServiceContentComponent,
  },
  {
    path: "e-tds",
    component: ETdsComponent,
  },
  {
    path: "e-tax-payment",
    component: ETaxPaymentComponent,
  },
  {
    path: "eLedger",
    component: ELedgerComponent,
  },
  {
      path: "user-manual",
      component: UserManualComponent,
  },
  // {
  //   path: "guideline",
  //   component: GuidelineComponent,
  // },
  // {
  //   path: "contact-us",
  //   component: ContactUsComponent,
  // },
  {
    path: "faq",
    component: FaqNewComponent,
  },
  {
    path: 'special-registration',
    loadChildren: () =>
      import('./special-registration/special-registration.module')
        .then(m => m.SpecialRegistrationModule)
  },
  {
    path: "special-registration-manual",
    component: SpecialRegistrationManualComponent,
  },
  {
    path: "special-registration-email-verification-manual",
    component: SpecialRegistrationEmailVerificationManualComponent,
  },
  {
    path: "tax-certificate-manual",
    component: TaxCertificateManualComponent
  },
  {
    path: "trp/:token/:refreshToken",
    component: TrpLandingComponent,
  },
  {
    path: "tax-certificate",
    component: IncomeTaxCertificateComponent
  },
  {
    path: "ack-rec",
    component: AacknowledgementSlipComponent
  },
  {
    path: '',
    component: BackgroundDefaultLayoutComponent,
    data: {
      title: 'Auth'
    },
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule)
      }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      // {
      //   path: 'base',
      //   loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      // },
      // {
      //   path: 'buttons',
      //   loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      // },
      // {
      //   path: 'charts',
      //   loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      // },
      // {
      //   path: 'dashboard',
      //   loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      // },
      // {
      //   path: 'icons',
      //   loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      // },
      // {
      //   path: 'notifications',
      //   loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      // },
      // {
      //   path: 'theme',
      //   loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      // },
      // {
      //   path: 'widgets',
      //   loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      // },
      {
        path: 'user-panel',
        canActivate: [AuthGuard],
        loadChildren: () => {
          const year = localStorage.getItem('CURRENT_ASSESSMENT_YEAR');

          switch(year){
            case '2025-2026':
              return import('./user-panel_25_26/user-pannel-25_26.module').then(m => m.UserPanel25_26Module);
            case '2026-2027':
              return import('./user-panel_26_27/user-pannel-26_27.module').then(m => m.UserPanel26_27Module);
            // case '2027-2028':
            //   return import('./user-panel_27_28/user-pannel-27_28.module').then(m => m.UserPanel27_28Module);
            // case '2028-2029':
            //   return import('./user-panel_28_29/user-pannel-28_29.module').then(m => m.UserPanel28_29Module);
            // case '2029-2030':
            //   return import('./user-panel_29_30/user-pannel-29_30.module').then(m => m.UserPanel29_30Module);
            default:
              return import('./user-pannel/user-pannel.module').then(m => m.UserPannelModule);
          }
        }
      }
    ]
  },
  {
    path: "submission-verification",
    loadChildren: () => import('./submission-verification/submission-verification.module').then(m => m.SubmissionVerificationModule)
  },
  { path: 'redirect/trp/:token', component:  TrpRedirectComponent},
  { path: '**', component: P404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), TaxCertificatesModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
